import { Button, ButtonProps } from '@nextui-org/react';
import { FaGear } from 'react-icons/fa6';
import Icon from '../base/Icon';

export default function SettingsButton(props: ButtonProps) {
  return (
    <Button {...props} isIconOnly className="settings-btn">
      <Icon icon={FaGear} />
    </Button>
  );
}
